import React from "react";
import { BulkTripVehicleUpdateComponent } from "../../components/bulk-trip-vehicle-update-component/bulk-trip-vehicle-update.component";

export const BulkTripVehicleUpdatePage = () => {
    return (
        <BulkTripVehicleUpdateComponent />
    );
};
